var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        {
          staticStyle: { height: "calc(100vh - 80px)", overflow: "scroll" },
          attrs: { fluid: "" }
        },
        [
          !_vm.loader
            ? _c(
                "div",
                { staticClass: "elc-card-club-count" },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "p-10" },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c("v-flex", { attrs: { xs12: "", md8: "" } }, [
                                _c(
                                  "div",
                                  { staticStyle: { margin: "16px 0" } },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-weight": "500",
                                          "font-size": "22px",
                                          color: "#596363"
                                        }
                                      },
                                      [_vm._v("Knowledge Base")]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md3: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      "append-icon": "search",
                                      label: "Search",
                                      "single-line": "",
                                      "hide-details": ""
                                    },
                                    model: {
                                      value: _vm.search,
                                      callback: function($$v) {
                                        _vm.search = $$v
                                      },
                                      expression: "search"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { xs12: "", md1: "" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "p-l-10 p-r-10" },
                                    [
                                      _c(
                                        "v-tooltip",
                                        { attrs: { bottom: "" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "elc-button-rounded",
                                              attrs: {
                                                slot: "activator",
                                                fab: ""
                                              },
                                              on: { click: _vm.openKBDialog },
                                              slot: "activator"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { dark: "" } },
                                                [_vm._v("add")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v("Add knowledge Base")
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "p-t-16 p-b-16" },
                    _vm._l(_vm.filterKB, function(kb) {
                      return _c(
                        "v-flex",
                        { key: kb.id, attrs: { xs12: "" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "m-t-20", attrs: { xs12: "" } },
                            [
                              _c("v-card-text", [
                                _c(
                                  "div",
                                  { staticStyle: { float: "right" } },
                                  [
                                    _c(
                                      "v-menu",
                                      {
                                        attrs: {
                                          "open-on-hover": "",
                                          "offset-y": ""
                                        }
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticStyle: {
                                              "margin-top": "0px"
                                            },
                                            attrs: {
                                              slot: "activator",
                                              icon: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                              }
                                            },
                                            slot: "activator"
                                          },
                                          [_c("v-icon", [_vm._v("more_vert")])],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list",
                                          [
                                            _c(
                                              "v-list-tile",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.editKBDialog(kb)
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticStyle: {
                                                          margin: "4px 4px 0 0"
                                                        },
                                                        attrs: {
                                                          slot: "activator",
                                                          small: ""
                                                        },
                                                        slot: "activator"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                    edit\n                                                "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      "\n                                                Edit\n                                            "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-list-tile",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.deleteKBDialog(kb)
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticStyle: {
                                                          margin: "4px 4px 0 0"
                                                        },
                                                        attrs: {
                                                          slot: "activator",
                                                          small: ""
                                                        },
                                                        slot: "activator"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                    delete\n                                                "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      "\n                                                Delete\n                                            "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "bizhome-knowledgebase" },
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { wrap: "" } },
                                      [
                                        _c("v-flex", { attrs: { xs12: "" } }, [
                                          _c("h2", [_vm._v(_vm._s(kb.title))])
                                        ]),
                                        _vm._v(" "),
                                        kb.message.attachments
                                          ? _c(
                                              "v-flex",
                                              { attrs: { xs12: "" } },
                                              [
                                                kb.message.attachments[0]
                                                  .type == 21
                                                  ? _c("div", [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href:
                                                              kb.message
                                                                .attachments[0]
                                                                .url,
                                                            target: "_blank"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                " +
                                                              _vm._s(
                                                                kb.message
                                                                  .attachments[0]
                                                                  .url
                                                              )
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        kb.message
                                          ? _c(
                                              "v-flex",
                                              { attrs: { xs12: "" } },
                                              [
                                                kb.type == 12
                                                  ? _c("div", [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href:
                                                              kb.message
                                                                .originalUrl,
                                                            target: "_blank"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                " +
                                                              _vm._s(
                                                                kb.message
                                                                  .originalUrl
                                                              )
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        kb.message.attachments
                                          ? _c(
                                              "v-flex",
                                              { attrs: { xs12: "" } },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(kb.message.text)
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !kb.message.attachments && kb.type != 12
                                          ? _c(
                                              "v-flex",
                                              { attrs: { xs12: "" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "m-t-10 m-b-10"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          "white-space":
                                                            "pre-line"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(kb.message)
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("v-flex", { attrs: { xs12: "" } }, [
                                          _c(
                                            "h6",
                                            _vm._l(
                                              kb.preparedFolderArr,
                                              function(item) {
                                                return _c("span", [
                                                  _vm._v(
                                                    "\n                                           " +
                                                      _vm._s(item) +
                                                      " /\n                                            "
                                                  )
                                                ])
                                              }
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs12: "" } },
                                          _vm._l(
                                            kb.resource_category_ids,
                                            function(cat, i) {
                                              return _c(
                                                "v-btn",
                                                {
                                                  key: i,
                                                  staticClass:
                                                    "elc-chip-button m-t-10 m-b-10"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "kbCategoryFilter"
                                                        )(cat)
                                                      ) +
                                                      "\n                                        "
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ),
                                        _vm._v(" "),
                                        kb.message.attachments
                                          ? _c(
                                              "v-flex",
                                              { attrs: { xs12: "" } },
                                              [
                                                kb.message.attachments[0]
                                                  .type != 21
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          height: "100px",
                                                          width: "100px",
                                                          border:
                                                            "0px solid black"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticStyle: {
                                                              height: "100px",
                                                              width: "100px"
                                                            },
                                                            attrs: {
                                                              href: kb.message
                                                                .attachments[0]
                                                                .url
                                                                ? _vm.prepareURL(
                                                                    kb.message
                                                                      .attachments[0]
                                                                      .url
                                                                  )
                                                                : kb.message
                                                                    .attachments[0]
                                                                    .url,
                                                              target: "_blank"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                class:
                                                                  kb.message
                                                                    .attachments[0]
                                                                    .type != 1
                                                                    ? "solid-border-1-b"
                                                                    : "no-border",
                                                                staticStyle: {
                                                                  height:
                                                                    "100px",
                                                                  width: "100px"
                                                                }
                                                              },
                                                              [
                                                                kb.message
                                                                  .attachments[0]
                                                                  .type == 1
                                                                  ? _c("img", {
                                                                      staticStyle: {
                                                                        height:
                                                                          "100px",
                                                                        width:
                                                                          "100px"
                                                                      },
                                                                      attrs: {
                                                                        src: kb
                                                                          .message
                                                                          .attachments[0]
                                                                          .url
                                                                          ? _vm.prepareURL(
                                                                              kb
                                                                                .message
                                                                                .attachments[0]
                                                                                .url
                                                                            )
                                                                          : kb
                                                                              .message
                                                                              .attachments[0]
                                                                              .url
                                                                      }
                                                                    })
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                kb.message
                                                                  .attachments[0]
                                                                  .type == 2
                                                                  ? _c("img", {
                                                                      staticStyle: {
                                                                        display:
                                                                          "block",
                                                                        margin:
                                                                          "auto",
                                                                        "padding-top":
                                                                          "23px"
                                                                      },
                                                                      attrs: {
                                                                        src: require("../../../static/assets/image/Video.png")
                                                                      }
                                                                    })
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                kb.message
                                                                  .attachments[0]
                                                                  .type == 3
                                                                  ? _c("img", {
                                                                      staticStyle: {
                                                                        display:
                                                                          "block",
                                                                        margin:
                                                                          "auto",
                                                                        "padding-top":
                                                                          "23px"
                                                                      },
                                                                      attrs: {
                                                                        src: require("../../../static/assets/image/File.png"),
                                                                        id:
                                                                          "downloadFileId"
                                                                      }
                                                                    })
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                kb.message
                                                                  .attachments[0]
                                                                  .type == 4
                                                                  ? _c("img", {
                                                                      staticStyle: {
                                                                        display:
                                                                          "block",
                                                                        margin:
                                                                          "auto",
                                                                        "padding-top":
                                                                          "23px"
                                                                      },
                                                                      attrs: {
                                                                        src: require("../../../static/assets/image/Audio.png")
                                                                      }
                                                                    })
                                                                  : _vm._e()
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    })
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.loader && (!_vm.KBData.length || _vm.searchFlag)
            ? _c("v-flex", { attrs: { xs12: "" } }, [
                _c(
                  "div",
                  { staticClass: "elc-card-club-count" },
                  [
                    _c("v-card", { staticClass: "p-16 text-xs-center" }, [
                      _vm._v("No Knowledgebase available.")
                    ])
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: {
                fullscreen: "",
                transition: "slide-x-reverse-transition",
                persistent: ""
              },
              on: {
                keydown: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
                  ) {
                    return null
                  }
                  return _vm.cancelKBDialog($event)
                }
              },
              model: {
                value: _vm.addKBDialog,
                callback: function($$v) {
                  _vm.addKBDialog = $$v
                },
                expression: "addKBDialog"
              }
            },
            [
              _c(
                "v-form",
                {
                  ref: "KBForm",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c("v-card", { staticClass: "elc-addmember-card" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          height: "calc(100vh - 50px)",
                          "overflow-y": "auto"
                        }
                      },
                      [
                        _c(
                          "v-container",
                          { attrs: { "grid-list-md": "" } },
                          [
                            _c(
                              "div",
                              { staticStyle: { position: "relative" } },
                              [
                                !_vm.addEditFlag
                                  ? _c("h2", { staticClass: "p-10" }, [
                                      _vm._v("Add Knowledge Base ")
                                    ])
                                  : _c("h2", { staticClass: "p-10" }, [
                                      _vm._v("Update Knowledge Base ")
                                    ]),
                                _vm._v(" "),
                                _c(
                                  "v-tooltip",
                                  {
                                    staticStyle: {
                                      position: "absolute",
                                      top: "0",
                                      right: "0"
                                    },
                                    attrs: { bottom: "" }
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { slot: "activator", icon: "" },
                                        on: { click: _vm.cancelKBDialog },
                                        slot: "activator"
                                      },
                                      [_c("v-icon", [_vm._v("clear")])],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("Close")])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              {
                                staticClass: "justify-space-between",
                                attrs: { wrap: "" }
                              },
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10",
                                    attrs: { xs12: "", md3: "" }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        items: _vm.constant.kbType,
                                        "item-text": "name",
                                        rules: _vm.fieldRules,
                                        "item-value": "id",
                                        label: "Select Type*",
                                        readonly: _vm.addEditFlag
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.showFieldType(_vm.kb.type)
                                        }
                                      },
                                      model: {
                                        value: _vm.kb.type,
                                        callback: function($$v) {
                                          _vm.$set(_vm.kb, "type", $$v)
                                        },
                                        expression: "kb.type"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-form",
                              { ref: "form", attrs: { "lazy-validation": "" } },
                              [
                                _vm.mediaFlag
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "p-10",
                                            attrs: { xs12: "" }
                                          },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Title*",
                                                rules: _vm.nameRules
                                              },
                                              model: {
                                                value: _vm.kb.title,
                                                callback: function($$v) {
                                                  _vm.$set(_vm.kb, "title", $$v)
                                                },
                                                expression: "kb.title"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "p-10",
                                            attrs: { xs12: "" }
                                          },
                                          [
                                            _c("v-textarea", {
                                              attrs: {
                                                label: "Description*",
                                                rules: _vm.fieldRules
                                              },
                                              model: {
                                                value: _vm.kb.description,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.kb,
                                                    "description",
                                                    $$v
                                                  )
                                                },
                                                expression: "kb.description"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-layout",
                                          { attrs: { wrap: "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "p-10",
                                                attrs: { xs12: "", md4: "" }
                                              },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label: "Select File*",
                                                    "prepend-icon":
                                                      "attach_file",
                                                    rules: _vm.fieldRules
                                                  },
                                                  nativeOn: {
                                                    click: function($event) {
                                                      return _vm.pickFile(
                                                        $event
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: _vm.fileName,
                                                    callback: function($$v) {
                                                      _vm.fileName = $$v
                                                    },
                                                    expression: "fileName"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _vm.kb.type == 1
                                                  ? _c("input", {
                                                      ref: "media",
                                                      staticClass: "fileId",
                                                      staticStyle: {
                                                        display: "none"
                                                      },
                                                      attrs: {
                                                        type: "file",
                                                        accept: "image/*"
                                                      },
                                                      on: {
                                                        input: _vm.onFilePicked
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.kb.type == 4
                                                  ? _c("input", {
                                                      ref: "media",
                                                      staticClass: "fileId",
                                                      staticStyle: {
                                                        display: "none"
                                                      },
                                                      attrs: {
                                                        type: "file",
                                                        accept: "audio/*"
                                                      },
                                                      on: {
                                                        input: _vm.onFilePicked
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.kb.type == 2
                                                  ? _c("input", {
                                                      ref: "media",
                                                      staticClass: "fileId",
                                                      staticStyle: {
                                                        display: "none"
                                                      },
                                                      attrs: {
                                                        type: "file",
                                                        accept: "video/*"
                                                      },
                                                      on: {
                                                        input: _vm.onFilePicked
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.kb.type == 3
                                                  ? _c("input", {
                                                      ref: "media",
                                                      staticClass: "fileId",
                                                      staticStyle: {
                                                        display: "none"
                                                      },
                                                      attrs: {
                                                        type: "file",
                                                        accept:
                                                          ".pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                      },
                                                      on: {
                                                        input: _vm.onFilePicked
                                                      }
                                                    })
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "p-10",
                                                attrs: { xs12: "", md8: "" }
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass:
                                                      "elc-button-radius-color",
                                                    attrs: {
                                                      disabled:
                                                        _vm.uploadBtnFlag
                                                    },
                                                    on: {
                                                      click: _vm.uploadFile
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass:
                                                          "p-t-10 p-r-10 p-b-10",
                                                        attrs: { small: "" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "cloud_upload\n                                                "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      "\n                                                Upload\n                                            "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "p-10",
                                            attrs: { xs12: "", md6: "" }
                                          },
                                          [
                                            _c("treeselect", {
                                              attrs: {
                                                options: _vm.folderData,
                                                normalizer: _vm.normalizer,
                                                "disable-branch-nodes": true,
                                                "show-count": true,
                                                placeholder: "Select Folder",
                                                noOptionsText:
                                                  "No folder available",
                                                required: ""
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "option-label",
                                                  fn: function(ref) {
                                                    var node = ref.node
                                                    var shouldShowCount =
                                                      ref.shouldShowCount
                                                    var count = ref.count
                                                    var labelClassName =
                                                      ref.labelClassName
                                                    var countClassName =
                                                      ref.countClassName
                                                    return _c(
                                                      "label",
                                                      { class: labelClassName },
                                                      [
                                                        node.isBranch
                                                          ? _c(
                                                              "span",
                                                              [
                                                                node.isExpanded
                                                                  ? _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          small:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "folder_open"
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          small:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "folder"
                                                                        )
                                                                      ]
                                                                    )
                                                              ],
                                                              1
                                                            )
                                                          : _c(
                                                              "span",
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      small: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "insert_drive_file"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(node.label)
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        shouldShowCount
                                                          ? _c(
                                                              "span",
                                                              {
                                                                class: countClassName
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "(" +
                                                                    _vm._s(
                                                                      count
                                                                    ) +
                                                                    ")"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  }
                                                }
                                              ]),
                                              model: {
                                                value: _vm.kb.folder,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.kb,
                                                    "folder",
                                                    $$v
                                                  )
                                                },
                                                expression: "kb.folder"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "p-10",
                                            attrs: { xs12: "", md6: "" }
                                          },
                                          [
                                            _c(
                                              "v-autocomplete",
                                              {
                                                attrs: {
                                                  items: _vm.categoriesArr,
                                                  "item-text": "name",
                                                  "item-value": "id",
                                                  label: "Category*",
                                                  multiple: "",
                                                  chips: "",
                                                  rules: _vm.fieldRules,
                                                  required: "",
                                                  close: ""
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "selection",
                                                    fn: function(data) {
                                                      return [
                                                        _c(
                                                          "v-chip",
                                                          {
                                                            staticClass:
                                                              "chip--select-multi",
                                                            attrs: {
                                                              selected:
                                                                data.selected,
                                                              close: ""
                                                            },
                                                            on: {
                                                              input: function(
                                                                $event
                                                              ) {
                                                                _vm.removeCategoryItem(
                                                                  data.item
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  data.item.name
                                                                ) +
                                                                "\n                                                "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ]),
                                                model: {
                                                  value: _vm.kb.categories,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.kb,
                                                      "categories",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "kb.categories"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-list-tile",
                                                  {
                                                    attrs: {
                                                      slot: "prepend-item",
                                                      ripple: ""
                                                    },
                                                    on: { click: _vm.toggle },
                                                    slot: "prepend-item"
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile-action",
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v(
                                                            _vm._s(_vm.icon)
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("v-list-tile-title", [
                                                      _vm._v("Select Category")
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("v-divider", {
                                                  staticClass: "mt-2",
                                                  attrs: {
                                                    slot: "prepend-item"
                                                  },
                                                  slot: "prepend-item"
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-layout",
                                          { attrs: { wrap: "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass:
                                                  "p-10 text-sm-right",
                                                attrs: { xs12: "" }
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass:
                                                      "elc-button-radius",
                                                    on: {
                                                      click: _vm.cancelKBDialog
                                                    }
                                                  },
                                                  [_vm._v("Cancel")]
                                                ),
                                                _vm._v(" "),
                                                !_vm.addEditFlag
                                                  ? _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "elc-button-radius-color",
                                                        attrs: {
                                                          disabled:
                                                            _vm.kb.title ==
                                                              "" ||
                                                            _vm.kb
                                                              .description ==
                                                              "" ||
                                                            _vm.kb.categories ==
                                                              null ||
                                                            _vm.kb.folder ==
                                                              null ||
                                                            !_vm.uploadBtnFlag ||
                                                            !_vm.valid
                                                        },
                                                        on: { click: _vm.addKB }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Save\n                                            "
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "elc-button-radius-color",
                                                        attrs: {
                                                          disabled:
                                                            _vm.kb.title ==
                                                              "" ||
                                                            _vm.kb
                                                              .description ==
                                                              "" ||
                                                            _vm.kb
                                                              .categories ===
                                                              null ||
                                                            _vm.kb.folder ==
                                                              null ||
                                                            !_vm.valid
                                                        },
                                                        on: {
                                                          click: _vm.updateKB
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Update\n                                            "
                                                        )
                                                      ]
                                                    )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.FAQFlag
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "p-10",
                                            attrs: { xs12: "" }
                                          },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Question*",
                                                rules: _vm.nameRules
                                              },
                                              model: {
                                                value: _vm.kb.title,
                                                callback: function($$v) {
                                                  _vm.$set(_vm.kb, "title", $$v)
                                                },
                                                expression: "kb.title"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "p-10",
                                            attrs: { xs12: "" }
                                          },
                                          [
                                            _c("v-textarea", {
                                              attrs: {
                                                label: "Answer*",
                                                rules: _vm.fieldRules
                                              },
                                              model: {
                                                value: _vm.kb.description,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.kb,
                                                    "description",
                                                    $$v
                                                  )
                                                },
                                                expression: "kb.description"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "p-10",
                                            attrs: { xs12: "", md6: "" }
                                          },
                                          [
                                            _c("treeselect", {
                                              attrs: {
                                                options: _vm.folderData,
                                                normalizer: _vm.normalizer,
                                                "disable-branch-nodes": true,
                                                "show-count": true,
                                                placeholder: "Select Folder",
                                                required: ""
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "option-label",
                                                  fn: function(ref) {
                                                    var node = ref.node
                                                    var shouldShowCount =
                                                      ref.shouldShowCount
                                                    var count = ref.count
                                                    var labelClassName =
                                                      ref.labelClassName
                                                    var countClassName =
                                                      ref.countClassName
                                                    return _c(
                                                      "label",
                                                      { class: labelClassName },
                                                      [
                                                        node.isBranch
                                                          ? _c(
                                                              "span",
                                                              [
                                                                node.isExpanded
                                                                  ? _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          small:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "folder_open"
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          small:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "folder"
                                                                        )
                                                                      ]
                                                                    )
                                                              ],
                                                              1
                                                            )
                                                          : _c(
                                                              "span",
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      small: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "insert_drive_file"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(node.label)
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        shouldShowCount
                                                          ? _c(
                                                              "span",
                                                              {
                                                                class: countClassName
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "(" +
                                                                    _vm._s(
                                                                      count
                                                                    ) +
                                                                    ")"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  }
                                                }
                                              ]),
                                              model: {
                                                value: _vm.kb.folder,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.kb,
                                                    "folder",
                                                    $$v
                                                  )
                                                },
                                                expression: "kb.folder"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "p-10",
                                            attrs: { xs12: "", md6: "" }
                                          },
                                          [
                                            _c(
                                              "v-autocomplete",
                                              {
                                                attrs: {
                                                  items: _vm.categoriesArr,
                                                  "item-text": "name",
                                                  "item-value": "id",
                                                  label: "Category*",
                                                  multiple: "",
                                                  chips: "",
                                                  rules: _vm.fieldRules,
                                                  required: "",
                                                  close: ""
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "selection",
                                                    fn: function(data) {
                                                      return [
                                                        data.item.name ===
                                                        _vm.constant
                                                          .kbType_const[5]
                                                          ? _c(
                                                              "v-chip",
                                                              {
                                                                staticClass:
                                                                  "chip&#45;&#45;select-multi",
                                                                attrs: {
                                                                  selected:
                                                                    data.selected
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      data.item
                                                                        .name
                                                                    ) +
                                                                    "\n                                                "
                                                                )
                                                              ]
                                                            )
                                                          : _c(
                                                              "v-chip",
                                                              {
                                                                staticClass:
                                                                  "chip&#45;&#45;select-multi",
                                                                attrs: {
                                                                  selected:
                                                                    data.selected,
                                                                  close: ""
                                                                },
                                                                on: {
                                                                  input: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.removeCategoryItem(
                                                                      data.item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      data.item
                                                                        .name
                                                                    ) +
                                                                    "\n                                                "
                                                                )
                                                              ]
                                                            )
                                                      ]
                                                    }
                                                  }
                                                ]),
                                                model: {
                                                  value: _vm.kb.categories,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.kb,
                                                      "categories",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "kb.categories"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-list-tile",
                                                  {
                                                    attrs: {
                                                      slot: "prepend-item",
                                                      ripple: ""
                                                    },
                                                    on: { click: _vm.toggle },
                                                    slot: "prepend-item"
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile-action",
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v(
                                                            _vm._s(_vm.icon)
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("v-list-tile-title", [
                                                      _vm._v("Select Category")
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("v-divider", {
                                                  staticClass: "mt-2",
                                                  attrs: {
                                                    slot: "prepend-item"
                                                  },
                                                  slot: "prepend-item"
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-layout",
                                          { attrs: { wrap: "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass:
                                                  "p-10 text-sm-right",
                                                attrs: { xs12: "" }
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass:
                                                      "elc-button-radius",
                                                    on: {
                                                      click: _vm.cancelKBDialog
                                                    }
                                                  },
                                                  [_vm._v("Cancel")]
                                                ),
                                                _vm._v(" "),
                                                !_vm.addEditFlag
                                                  ? _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "elc-button-radius-color",
                                                        attrs: {
                                                          disabled:
                                                            _vm.kb.title ==
                                                              "" ||
                                                            _vm.kb
                                                              .description ==
                                                              "" ||
                                                            _vm.kb.categories ==
                                                              null ||
                                                            _vm.kb.folder ==
                                                              null ||
                                                            !_vm.valid
                                                        },
                                                        on: { click: _vm.addKB }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Save\n                                            "
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "elc-button-radius-color",
                                                        attrs: {
                                                          disabled:
                                                            _vm.kb.title ==
                                                              "" ||
                                                            _vm.kb
                                                              .description ==
                                                              "" ||
                                                            _vm.kb
                                                              .categories ===
                                                              null ||
                                                            _vm.kb.folder ==
                                                              null ||
                                                            !_vm.valid
                                                        },
                                                        on: {
                                                          click: _vm.updateKB
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Update\n                                            "
                                                        )
                                                      ]
                                                    )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.textFlag
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "p-10",
                                            attrs: { xs12: "" }
                                          },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Title*",
                                                rules: _vm.nameRules
                                              },
                                              model: {
                                                value: _vm.kb.title,
                                                callback: function($$v) {
                                                  _vm.$set(_vm.kb, "title", $$v)
                                                },
                                                expression: "kb.title"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        !_vm.urlFlag
                                          ? _c(
                                              "v-flex",
                                              {
                                                staticClass: "p-10",
                                                attrs: { xs12: "" }
                                              },
                                              [
                                                _c("v-textarea", {
                                                  attrs: {
                                                    label: "Description*",
                                                    rules: _vm.fieldRules
                                                  },
                                                  model: {
                                                    value: _vm.kb.description,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.kb,
                                                        "description",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "kb.description"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _c(
                                              "v-flex",
                                              {
                                                staticClass: "p-10",
                                                attrs: { xs12: "" }
                                              },
                                              [
                                                _c("v-textarea", {
                                                  attrs: {
                                                    label: "URL*",
                                                    rules: _vm.fieldRules
                                                  },
                                                  model: {
                                                    value: _vm.kb.description,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.kb,
                                                        "description",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "kb.description"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "p-10",
                                            attrs: { xs12: "", md6: "" }
                                          },
                                          [
                                            _c("treeselect", {
                                              attrs: {
                                                options: _vm.folderData,
                                                normalizer: _vm.normalizer,
                                                "disable-branch-nodes": true,
                                                "show-count": true,
                                                placeholder: "Select Folder",
                                                required: ""
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "option-label",
                                                  fn: function(ref) {
                                                    var node = ref.node
                                                    var shouldShowCount =
                                                      ref.shouldShowCount
                                                    var count = ref.count
                                                    var labelClassName =
                                                      ref.labelClassName
                                                    var countClassName =
                                                      ref.countClassName
                                                    return _c(
                                                      "label",
                                                      { class: labelClassName },
                                                      [
                                                        node.isBranch
                                                          ? _c(
                                                              "span",
                                                              [
                                                                node.isExpanded
                                                                  ? _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          small:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "folder_open"
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          small:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "folder"
                                                                        )
                                                                      ]
                                                                    )
                                                              ],
                                                              1
                                                            )
                                                          : _c(
                                                              "span",
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      small: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "insert_drive_file"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(node.label)
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        shouldShowCount
                                                          ? _c(
                                                              "span",
                                                              {
                                                                class: countClassName
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "(" +
                                                                    _vm._s(
                                                                      count
                                                                    ) +
                                                                    ")"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  }
                                                }
                                              ]),
                                              model: {
                                                value: _vm.kb.folder,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.kb,
                                                    "folder",
                                                    $$v
                                                  )
                                                },
                                                expression: "kb.folder"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "p-10",
                                            attrs: { xs12: "", md6: "" }
                                          },
                                          [
                                            _c(
                                              "v-autocomplete",
                                              {
                                                attrs: {
                                                  items: _vm.categoriesArr,
                                                  "item-text": "name",
                                                  "item-value": "id",
                                                  label: "Category*",
                                                  multiple: "",
                                                  chips: "",
                                                  rules: _vm.fieldRules,
                                                  required: "",
                                                  close: ""
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "selection",
                                                    fn: function(data) {
                                                      return [
                                                        _c(
                                                          "v-chip",
                                                          {
                                                            staticClass:
                                                              "chip&#45;&#45;select-multi",
                                                            attrs: {
                                                              selected:
                                                                data.selected,
                                                              close: ""
                                                            },
                                                            on: {
                                                              input: function(
                                                                $event
                                                              ) {
                                                                _vm.removeCategoryItem(
                                                                  data.item
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  data.item.name
                                                                ) +
                                                                "\n                                                "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ]),
                                                model: {
                                                  value: _vm.kb.categories,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.kb,
                                                      "categories",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "kb.categories"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-list-tile",
                                                  {
                                                    attrs: {
                                                      slot: "prepend-item",
                                                      ripple: ""
                                                    },
                                                    on: { click: _vm.toggle },
                                                    slot: "prepend-item"
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile-action",
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v(
                                                            _vm._s(_vm.icon)
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("v-list-tile-title", [
                                                      _vm._v("Select Category")
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("v-divider", {
                                                  staticClass: "mt-2",
                                                  attrs: {
                                                    slot: "prepend-item"
                                                  },
                                                  slot: "prepend-item"
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-layout",
                                          { attrs: { wrap: "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass:
                                                  "p-10 text-sm-right",
                                                attrs: { xs12: "" }
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass:
                                                      "elc-button-radius",
                                                    on: {
                                                      click: _vm.cancelKBDialog
                                                    }
                                                  },
                                                  [_vm._v("Cancel")]
                                                ),
                                                _vm._v(" "),
                                                !_vm.addEditFlag
                                                  ? _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "elc-button-radius-color",
                                                        attrs: {
                                                          disabled:
                                                            _vm.kb.title ==
                                                              "" ||
                                                            _vm.kb
                                                              .description ==
                                                              "" ||
                                                            _vm.kb.categories ==
                                                              null ||
                                                            _vm.kb.folder ==
                                                              null ||
                                                            !_vm.valid
                                                        },
                                                        on: { click: _vm.addKB }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Save\n                                            "
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "elc-button-radius-color",
                                                        attrs: {
                                                          disabled:
                                                            _vm.kb.title ==
                                                              "" ||
                                                            _vm.kb
                                                              .description ==
                                                              "" ||
                                                            _vm.kb
                                                              .categories ===
                                                              null ||
                                                            _vm.kb.folder ==
                                                              null ||
                                                            !_vm.valid
                                                        },
                                                        on: {
                                                          click: _vm.updateKB
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Update\n                                            "
                                                        )
                                                      ]
                                                    )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.utubeFlag
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "p-10",
                                            attrs: { xs12: "" }
                                          },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Title*",
                                                rules: _vm.nameRules
                                              },
                                              model: {
                                                value: _vm.kb.title,
                                                callback: function($$v) {
                                                  _vm.$set(_vm.kb, "title", $$v)
                                                },
                                                expression: "kb.title"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "p-10",
                                            attrs: { xs12: "" }
                                          },
                                          [
                                            _c("v-textarea", {
                                              attrs: {
                                                label: "Description*",
                                                rules: _vm.fieldRules
                                              },
                                              model: {
                                                value: _vm.kb.description,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.kb,
                                                    "description",
                                                    $$v
                                                  )
                                                },
                                                expression: "kb.description"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-layout",
                                          { attrs: { wrap: "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "p-10",
                                                attrs: { xs12: "" }
                                              },
                                              [
                                                _c("v-textarea", {
                                                  attrs: {
                                                    label: "URL*",
                                                    rules: _vm.fieldRules
                                                  },
                                                  model: {
                                                    value: _vm.kb.utubeURL,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.kb,
                                                        "utubeURL",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "kb.utubeURL"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "p-10",
                                            attrs: { xs12: "", md6: "" }
                                          },
                                          [
                                            _c("treeselect", {
                                              attrs: {
                                                options: _vm.folderData,
                                                normalizer: _vm.normalizer,
                                                "disable-branch-nodes": true,
                                                "show-count": true,
                                                placeholder: "Select Folder",
                                                required: ""
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "option-label",
                                                  fn: function(ref) {
                                                    var node = ref.node
                                                    var shouldShowCount =
                                                      ref.shouldShowCount
                                                    var count = ref.count
                                                    var labelClassName =
                                                      ref.labelClassName
                                                    var countClassName =
                                                      ref.countClassName
                                                    return _c(
                                                      "label",
                                                      { class: labelClassName },
                                                      [
                                                        node.isBranch
                                                          ? _c(
                                                              "span",
                                                              [
                                                                node.isExpanded
                                                                  ? _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          small:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "folder_open"
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          small:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "folder"
                                                                        )
                                                                      ]
                                                                    )
                                                              ],
                                                              1
                                                            )
                                                          : _c(
                                                              "span",
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      small: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "insert_drive_file"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(node.label)
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        shouldShowCount
                                                          ? _c(
                                                              "span",
                                                              {
                                                                class: countClassName
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "(" +
                                                                    _vm._s(
                                                                      count
                                                                    ) +
                                                                    ")"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  }
                                                }
                                              ]),
                                              model: {
                                                value: _vm.kb.folder,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.kb,
                                                    "folder",
                                                    $$v
                                                  )
                                                },
                                                expression: "kb.folder"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "p-10",
                                            attrs: { xs12: "", md6: "" }
                                          },
                                          [
                                            _c(
                                              "v-autocomplete",
                                              {
                                                attrs: {
                                                  items: _vm.categoriesArr,
                                                  "item-text": "name",
                                                  "item-value": "id",
                                                  label: "Category*",
                                                  multiple: "",
                                                  chips: "",
                                                  rules: _vm.fieldRules,
                                                  required: "",
                                                  close: ""
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "selection",
                                                    fn: function(data) {
                                                      return [
                                                        data.item.name ===
                                                        "Videos"
                                                          ? _c(
                                                              "v-chip",
                                                              {
                                                                staticClass:
                                                                  "chip--select-multi",
                                                                attrs: {
                                                                  selected:
                                                                    data.selected
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      data.item
                                                                        .name
                                                                    ) +
                                                                    "\n                                                "
                                                                )
                                                              ]
                                                            )
                                                          : _c(
                                                              "v-chip",
                                                              {
                                                                staticClass:
                                                                  "chip--select-multi",
                                                                attrs: {
                                                                  selected:
                                                                    data.selected,
                                                                  close: ""
                                                                },
                                                                on: {
                                                                  input: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.removeCategoryItem(
                                                                      data.item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      data.item
                                                                        .name
                                                                    ) +
                                                                    "\n                                                "
                                                                )
                                                              ]
                                                            )
                                                      ]
                                                    }
                                                  }
                                                ]),
                                                model: {
                                                  value: _vm.kb.categories,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.kb,
                                                      "categories",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "kb.categories"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-list-tile",
                                                  {
                                                    attrs: {
                                                      slot: "prepend-item",
                                                      ripple: ""
                                                    },
                                                    on: { click: _vm.toggle },
                                                    slot: "prepend-item"
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile-action",
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v(
                                                            _vm._s(_vm.icon)
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("v-list-tile-title", [
                                                      _vm._v("Select Category")
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("v-divider", {
                                                  staticClass: "mt-2",
                                                  attrs: {
                                                    slot: "prepend-item"
                                                  },
                                                  slot: "prepend-item"
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-layout",
                                          { attrs: { wrap: "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass:
                                                  "p-10 text-sm-right",
                                                attrs: { xs12: "" }
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass:
                                                      "elc-button-radius",
                                                    on: {
                                                      click: _vm.cancelKBDialog
                                                    }
                                                  },
                                                  [_vm._v("Cancel")]
                                                ),
                                                _vm._v(" "),
                                                !_vm.addEditFlag
                                                  ? _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "elc-button-radius-color",
                                                        attrs: {
                                                          disabled:
                                                            _vm.kb.title ==
                                                              "" ||
                                                            _vm.kb
                                                              .description ==
                                                              "" ||
                                                            _vm.kb
                                                              .categories ===
                                                              null ||
                                                            _vm.kb.folder ==
                                                              null ||
                                                            _vm.kb.utubeURL ==
                                                              null ||
                                                            !_vm.valid
                                                        },
                                                        on: { click: _vm.addKB }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Save\n                                            "
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "elc-button-radius-color",
                                                        attrs: {
                                                          disabled:
                                                            _vm.kb.title ==
                                                              "" ||
                                                            _vm.kb
                                                              .description ==
                                                              "" ||
                                                            _vm.kb
                                                              .categories ===
                                                              null ||
                                                            _vm.kb.folder ==
                                                              null ||
                                                            _vm.kb.utubeURL ==
                                                              null ||
                                                            !_vm.valid
                                                        },
                                                        on: {
                                                          click: _vm.updateKB
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Update\n                                            "
                                                        )
                                                      ]
                                                    )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.delDialog
            ? _c("delete-confirm-dialog", {
                attrs: {
                  deleteConfirmDialog: _vm.delDialog,
                  deleteName: "Knowledgebase"
                },
                on: {
                  close: function($event) {
                    _vm.delDialog = false
                  },
                  delete: _vm.deleteKB
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("alert-modal", {
            attrs: { alertMsg: _vm.msg, alertMsgDialog: _vm.alertDialog },
            on: {
              closeAlert: function($event) {
                _vm.alertDialog = false
              }
            }
          }),
          _vm._v(" "),
          _vm.loader ? _c("loader") : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b32a5a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b32a5a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KnowledgeBase/KnowledgeBase.vue
// module id = null
// module chunks = 